import { initializeApp } from "firebase/app";
const firebaseConfig = {
  apiKey: "AIzaSyAEPsvjCKsKyszjms52sKd0zwRgDeqgAos",
  authDomain: "reformed-seminary.firebaseapp.com",
  projectId: "reformed-seminary",
  storageBucket: "reformed-seminary.appspot.com",
  messagingSenderId: "580718006503",
  appId: "1:580718006503:web:e2fa005144c54f426c5242",
  measurementId: "G-4S7NCBEDC7"
};
const app = initializeApp(firebaseConfig);
export default app